import React from 'react';
import styled from './styles';

export interface BreadcrumbCompactsHeaderProps extends React.ComponentPropsWithRef<'div'> {
  /** Children prop is where header content resides. */
  children: React.ReactNode;
}

/**
 * Single BreadcrumbCompactsHeader component.
 * Any other props than `children` will be provided to the root element. */
const BreadcrumbCompactsHeader = React.forwardRef<HTMLElement, BreadcrumbCompactsHeaderProps>((props: BreadcrumbCompactsHeaderProps, ref) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <styled.HeaderWrapper ref={ref} {...otherProps}>
      {children}
    </styled.HeaderWrapper>
  );
});

BreadcrumbCompactsHeader.displayName = 'BreadcrumbCompactsHeader';

export default BreadcrumbCompactsHeader;
